import React, { useCallback, useEffect, useRef } from 'react';
import { Button, Modal, Progress, Checkbox } from 'antd';
import dayjs from 'dayjs';
import Util from '../../script/util';
import './index.scss';

/**
 * 客户端更新弹窗
 * */
const ElectronExeUpdateModal = ({
  base,
  visible,
  info,
  downProcess,
  downSuccess,
  downError,
  changeError,
  closeModal,
}) => {
  const timer = useRef(null);
  const [btnLoading, setBtnLoading] = React.useState(false);
  const [releaseNotes, setReleaseNotes] = React.useState([]);
  const [isForceUpdate, setIsForceUpdate] = React.useState(false); // 是否强制更新
  const [isCheckedBox, setIsCheckedBox] = React.useState(false); // 是否勾选不再提醒
  const [downTime, setDownTime] = React.useState(-1); // 安装倒计时
  useEffect(() => {
    if (!!visible) {
      setIsCheckedBox(false);
    }
  }, [visible]);
  /* eslint-disable */
  useEffect(() => {
    let isForceUpdate = false;
    if (info?.vendor) {
      isForceUpdate = info.vendor?.isForceUpdate || false;
    }
    if (info.releaseNotes) {
      const releaseNotes = info.releaseNotes.split('\n');
      if (releaseNotes?.length) {
        const notes = [];
        releaseNotes.forEach((item) => {
          // 判断如果跳跃多个版本时，中间是否有强制更新的版本
          if (item.indexOf('changeLogs') > -1) {
            if (!isForceUpdate) {
              isForceUpdate = changeLogsIsForceUpdate(item);
            }
          } else {
            notes.push(item);
          }
        });
        setReleaseNotes(notes);
      }
    }
    setIsForceUpdate(isForceUpdate);
  }, [info]);
  /* eslint-disable */
  useEffect(() => {
    if (base?.client !== 'UELE' || Util.checkClientVersion(318)) {
      // 老版本 zip 客户端无法自动安装
      if (!!downSuccess) {
        if (isForceUpdate) {
          setDownTime(3); // 强制更新3s后自动安装
        } else {
          setDownTime(10); // 非强制更新10s后自动安装
        }
      }
    }
  }, [downSuccess, isForceUpdate]);
  // 安装倒计时
  useEffect(() => {
    if (downTime === 0) {
      clearTimeout(timer.current);
      onInstall();
    } else {
      timer.current = setTimeout(() => {
        setDownTime(downTime - 1);
      }, 1000);
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [downTime]);
  useEffect(() => {
    if (downError) {
      setBtnLoading(false);
    }
  }, [downError]);
  // 条约多个版本是，中间是否有强制更新版本
  const changeLogsIsForceUpdate = useCallback(
    (changeLogs) => {
      if (!base?.clientInfo?.version) return false;
      let curClientVersion = base.clientInfo.version || null;
      if (curClientVersion)
        curClientVersion = parseInt(curClientVersion.replace(/\./g, ''));
      let logsTxt = changeLogs.replace(/changeLogs:\s+/, '');
      if (typeof logsTxt === 'string') {
        const logs = logsTxt.split(',');
        if (logs?.length) {
          for (let i = 0; i < logs.length; i++) {
            const item = logs[i].split('-');
            const v = parseInt(item[0].replace(/\./g, ''));
            if (curClientVersion < v) {
              if (item[1] === 'true') {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    [base]
  );

  const onCheckboxChange = (event) => {
    setIsCheckedBox(event.target.checked);
    window.localStorage.setItem(
      'dd-electron-update-tip',
      Number(event.target.checked)
    );
  };
  const onOk = () => {
    setBtnLoading(true);
    changeError(false);
    window.eleEvents.downloadUpdate();
  };
  const onInstall = () => {
    window.eleEvents.installUpdate();
  };
  const onCancel = () => {
    closeModal();
  };

  // kb 转 mb
  const kbToMb = (kb) => {
    return (kb / 1024 / 1024).toFixed(2);
  };

  return (
    <Modal
      className="electron-update-modal"
      open={visible}
      title={null}
      centered
      footer={null}
      onCancel={onCancel}
      closable={!downSuccess && !isForceUpdate}
      maskClosable={false}
      zIndex={1009}
    >
      <h3 className="title">发现新版本!</h3>
      <ol className="content">
        <p className="line">
          <span className="mini">
            更新时间：{dayjs(info.releaseDate).format('YYYY-MM-DD')}
          </span>
          <span>最新版本: {info.version}</span>
          {!!info?.files?.length && (
            <span className="mini">安装包：{kbToMb(info.files[0].size)}MB</span>
          )}
        </p>
        <hr />
        {!!releaseNotes?.length &&
          releaseNotes.map((item, index) => <li key={index}>{item}</li>)}
      </ol>

      {!isForceUpdate && (
        <p className="checkbox">
          <Checkbox checked={isCheckedBox} onChange={onCheckboxChange}>
            不在提醒
          </Checkbox>
        </p>
      )}
      <p className="link">
        <Button type="link" onClick={() => window.eleEvents.openExternalLink()}>
          点击进入官网
        </Button>
      </p>
      {downError ? (
        <div className="tip">{downError}</div>
      ) : (
        !!downProcess && (
          <div className="process">
            <Progress
              strokeColor={{ from: '#dc58c5', to: '#f27661' }}
              percent={parseInt(downProcess)}
              status="active"
            />
          </div>
        )
      )}
      {base?.client === 'UELE' && !info?.isUpdaterFile && (
        <h3 className="tip">
          此安装包需要手动解压安装，点击立即更新选择文件下载位置
        </h3>
      )}
      <div className="footer">
        {!isForceUpdate && !downProcess && (
          <Button className="daidai-btn-primary cancel" onClick={onCancel}>
            稍后更新
          </Button>
        )}
        {!downSuccess && (
          <Button
            className="daidai-btn-primary"
            loading={btnLoading}
            onClick={onOk}
          >
            立即下载
          </Button>
        )}
        {downSuccess && (
          <Button className="daidai-btn-primary" onClick={onInstall}>
            立即安装{downTime > 0 && `(${downTime}s)`}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default ElectronExeUpdateModal;
